import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=44f7e331"
import script from "./tables.vue?vue&type=script&lang=ts"
export * from "./tables.vue?vue&type=script&lang=ts"
import style0 from "./tables.vue?vue&type=style&index=0&id=44f7e331&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports